import { Images } from "assets";
import { Svg } from "assets/svg";
import React, { useState, useEffect } from "react";
import {
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import { fp, hp, wp } from "utils/normalizeV2";
import VText from "components/VText";
import BottomSheetModal from "components/BottomSheetModal";
import Buttons from "components/Buttons";
import { useRef } from "react";
import SimilarProducts from "../similarProducts";

const CustomizeLook = ({
  outfitData,
  selectedProducts,
  setSelectedProducts,
  setCurrentPageId,
  showSimilarProducts,
}) => {
  useEffect(() => {
    if (selectedProducts.length === 0) {
      setSelectedProducts(outfitData);
    }
  }, [outfitData]);

  useEffect(() => {}, [selectedProducts]);
  const [productToRemove, setProductToRemove] = useState(null);

  const removeProductConfirmationRef = useRef();

  const hideRemoveProductConfirmation = () => {
    setProductToRemove(null);
    removeProductConfirmationRef?.current?.hide();
  };

  const handleRemoveProduct = (product) => {
    setProductToRemove(product);
    removeProductConfirmationRef?.current?.show();
  };

  const handleRemoveProductConfirmation = () => {
    let newSelectedProducts = selectedProducts.filter(
      (item) => item.id !== productToRemove.id
    );
    setSelectedProducts(newSelectedProducts);
    setProductToRemove(null);
    removeProductConfirmationRef?.current?.hide();
  };

  const renderGridItem = (item) => (
    <TouchableOpacity key={item.id} style={styles.gridItem}>
      <TouchableOpacity
        onPress={() => {
          showSimilarProducts(item);
        }}
        style={styles.imageContainer}
      >
        <Image
          source={{ uri: item?.imageUrls[0] }}
          style={styles.productImage}
          resizeMode="cover"
        />
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.removeProductButton}
        onPress={() => {
          handleRemoveProduct(item);
        }}
      >
        <Image source={Svg.closeIcon} style={styles.checkIcon} />
      </TouchableOpacity>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <VText style={styles.title}>
        Tap to view and replace with a product you like
      </VText>
      <View style={styles.gridContainer}>
        {selectedProducts?.map(renderGridItem)}
      </View>
      {selectedProducts?.length > 0 && (
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.selectedProductsContainer}
          contentContainerStyle={styles.selectedProductsContent}
        ></ScrollView>
      )}

      <BottomSheetModal
        MAX_HEIGHT_PERC={1}
        START_PERC={1}
        ref={removeProductConfirmationRef}
        hideLine
        containerStyle={{
          backgroundColor: "transparent",
          zIndex: 100,
        }}
      >
        <TouchableOpacity
          style={{
            backgroundColor: "transparent",
            width: "100%",
            height: hp(750),
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            zIndex: 100,
            cursor: "auto",
          }}
          activeOpacity={1}
          onPress={() => hideRemoveProductConfirmation()}
        >
          <View style={styles.modalContainer}>
            <View style={styles.modalContent}>
              <VText style={styles.modalTitle}>
                Are you sure you want to remove this product from the outfit?
              </VText>
              <View style={styles.modalButtonsContainer}>
                <TouchableOpacity
                  onPress={handleRemoveProductConfirmation}
                  style={{
                    ...styles.modalButton,
                    borderRightWidth: 1,
                    borderRightColor: "#3C3C435C",
                  }}
                >
                  <VText
                    style={{ ...styles.modalButtonText, fontWeight: "400" }}
                  >
                    Confirm
                  </VText>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => hideRemoveProductConfirmation()}
                  style={styles.modalButton}
                >
                  <VText style={{ ...styles.modalButtonText }}>Cancel</VText>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      </BottomSheetModal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
  },
  title: {
    fontSize: fp(18),
    fontWeight: "400",
    color: "#21242799",
    textAlign: "center",
    marginBottom: hp(10),
  },
  gridContainer: {
    marginLeft: wp(5),
    width: "100%",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: wp(50),
    gap: wp(10),
  },
  gridItem: {
    width: "49%",
    // marginRight: wp(5),
    borderRadius: wp(2),
    overflow: "hidden",
  },
  imageContainer: {
    width: "100%",
    aspectRatio: 1,
    height: hp(350),
    overflow: "hidden",
    position: "relative",
  },
  productImage: {
    width: "100%",
    height: "100%",
  },
  removeProductButton: {
    position: "absolute",
    top: wp(20),
    right: wp(20),
  },
  checkIcon: {
    width: wp(20),
    height: wp(20),
  },
  selectedProductsContainer: {
    marginTop: hp(20),
  },
  selectedProductsContent: {
    paddingHorizontal: wp(5),
    flexDirection: "row",
  },
  selectedProduct: {
    width: wp(150),
    height: wp(150),
  },
  modalContainer: {
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: wp(350),
    height: hp(150),
    backgroundColor: "white",
    // borderRadius: wp(3),
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: wp(20),
  },
  modalTitle: {
    fontSize: fp(18),
    fontWeight: "400",
    color: "black",
    textAlign: "center",
    marginTop: hp(20),
  },
  modalButtonsContainer: {
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "center",
    marginTop: hp(30),
  },
  modalButton: {
    width: wp(135),
    height: hp(50),
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
    borderTopWidth: 1,
    borderColor: "#3C3C435C",
  },
  modalButtonText: {
    fontSize: fp(16),
    fontWeight: "600",
    color: "#212427",
  },
});

export default React.memo(CustomizeLook);
